@if (showAsDialog) {
  <div class="modal-header">
    <h2 class="modal-title">Visits</h2>
  </div>
}

<div class="page-content page-fill">
  @if (!showAsDialog) {
    <div class="dx-toolbar mb-3">
      <button (click)="close()" class="btn btn-primary" [hidden]="hasChanges">Close</button>
      <button (click)="save()" class="btn btn-success" [hidden]="!hasChanges">Save</button>
      <button (click)="cancel()" class="btn btn-default" [hidden]="!hasChanges">Cancel</button>
      <!-- <h2 class="d-block ms-4">{{ person?.displayName }}</h2> -->
    </div>
  }

  <div class="row">
    <div class="col-sm-6">
      <div style="max-width: 600px">
        <dx-form [formData]="visit" validationGroup="statusChangeData">
          <dxi-item
            dataField="personId"
            [label]="{ text: 'Member' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'name' }"
          ></dxi-item>
          <dxi-item dataField="date" editorType="dxDateBox"></dxi-item>
          <dxi-item
            dataField="typeId"
            [label]="{ text: 'Type' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: types, valueExpr: 'id', displayExpr: 'name' }"
          ></dxi-item>
          <dxi-item
            dataField="visitedById"
            [label]="{ text: 'Visited By' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'name' }"
          ></dxi-item>
          <dxi-item dataField="notes" [editorType]="'dxTextArea'" [editorOptions]="{ height: '200px' }"></dxi-item>
        </dx-form>
      </div>
    </div>

    @if (appInfo.graafschap) {
      <div class="col-sm-6 p-3">
        <dx-data-grid
          #dataGrid
          keyExpr="id"
          [dataSource]="previousVisits"
          [wordWrapEnabled]="true"
          [rowAlternationEnabled]="false"
          [showBorders]="true"
          height="100%"
          >
          <dxi-column dataField="date" [width]="100" dataType="date"></dxi-column>
          <dxi-column dataField="by" [width]="135"></dxi-column>
          <dxi-column dataField="notes"></dxi-column>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="visit-history-grid"></dxo-state-storing>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
@if (showAsDialog) {
  <div class="modal-footer">
    <button (click)="save()" class="btn btn-success">Save</button>
    <button (click)="cancel()" class="btn btn-default">Cancel</button>
  </div>
}
